import { render } from "./RadioButton.vue?vue&type=template&id=36154531&scoped=true"
import script from "./RadioButton.vue?vue&type=script&lang=ts"
export * from "./RadioButton.vue?vue&type=script&lang=ts"

import "./RadioButton.vue?vue&type=style&index=0&id=36154531&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-36154531"

export default script